import ApiService from "../Services/ApiService";
import {
  MlmCommissionsParams,
  MlmCommissionsResponse,
  MlmDashboardStats,
  MlmSummary,
  MlmTreeResponse,
} from "../Objects/interfaces/MlmTypes";

/**
 * MIP-250 / MIP-251 – Endpoints du parrainage multi-niveaux (Verified Trainer).
 * Un coach ne peut consulter que son propre arbre (contrôle JWT côté backend).
 */
export default abstract class MlmRepository {
  public static getTree(teachrId: number): Promise<MlmTreeResponse> {
    return ApiService.get(`/mlm/tree/${teachrId}`);
  }

  public static getSummary(teachrId: number): Promise<MlmSummary> {
    return ApiService.get(`/mlm/summary/${teachrId}`);
  }

  /** Accueil : filleuls par niveau et commissions validées (en attente à part), ce mois et en cumul. */
  public static getDashboardStats(teachrId: number): Promise<MlmDashboardStats> {
    return ApiService.get(`/mlm/dashboard/${teachrId}`);
  }

  public static getCommissions(
    teachrId: number,
    { page, limit, level, from, to, status }: MlmCommissionsParams = {}
  ): Promise<MlmCommissionsResponse> {
    const params = new URLSearchParams();
    if (page !== undefined) params.set("page", page.toString());
    if (limit !== undefined) params.set("limit", limit.toString());
    if (level !== undefined) params.set("level", level.toString());
    if (from) params.set("from", from);
    if (to) params.set("to", to);
    if (status) params.set("status", status);
    const query = params.toString();
    return ApiService.get(`/mlm/commissions/${teachrId}${query ? `?${query}` : ""}`);
  }
}
